var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 134,
    viewBox: "0 0 85 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.42 133.194C29.66 133.194 23.78 132.594 17.78 131.394C11.9 130.314 6.14 128.814 0.5 126.894L3.74 99.354C7.94 100.914 12.26 102.234 16.7 103.314C21.26 104.274 25.52 104.754 29.48 104.754C34.64 104.754 38.9 103.794 42.26 101.874C45.74 99.954 47.48 96.774 47.48 92.334C47.48 88.134 45.98 85.014 42.98 82.974C40.1 80.934 35.24 79.914 28.4 79.914H15.26V53.634H28.94C35.66 53.634 40.4 52.554 43.16 50.394C46.04 48.234 47.48 44.874 47.48 40.314C47.48 36.114 45.74 33.234 42.26 31.674C38.9 29.994 34.76 29.154 29.84 29.154C26.48 29.154 22.94 29.454 19.22 30.054C15.62 30.534 12.14 31.194 8.78 32.034L3.74 6.29403C9.74 4.37404 15.74 2.93404 21.74 1.97404C27.86 0.894035 33.74 0.354035 39.38 0.354035C47.42 0.354035 54.68 1.49403 61.16 3.77403C67.64 5.93403 72.8 9.41404 76.64 14.214C80.6 18.894 82.64 25.134 82.76 32.934C82.76 41.214 81.2 47.994 78.08 53.274C74.96 58.554 70.22 62.754 63.86 65.874V66.234C69.98 68.514 74.9 72.054 78.62 76.854C82.34 81.654 84.2 88.194 84.2 96.474C84.2 104.874 81.92 111.834 77.36 117.354C72.92 122.754 66.98 126.774 59.54 129.414C52.22 131.934 44.18 133.194 35.42 133.194Z",
    fill: "url(#paint0_linear_7699_381)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7699_381",
    x1: 41.5,
    y1: -47.606,
    x2: 41.1209,
    y2: 117.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33472,
    stopColor: "#1A76D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.170ad2610eaf5889dbf32ee44f9afb1f.svg";
export { ForwardRef as ReactComponent };